import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Tabs, Tab } from 'react-bootstrap'
import QuickReplies from './quick-replies.js'
import CallToActions from './call-to-actions.js'
import { validateQuickReplies, validateCallToActions } from './validation'
import './dm-attachments.css'

const DmAttachments = ({ name }) => (
  <div className='br-dm-attachments'>
    <Tabs defaultActiveKey={1} id='br-tabs'>
      <Tab eventKey={1} title='Quick Replies'>
        <Field
          component={QuickReplies}
          name={`${name}.quickReply`}
          validate={validateQuickReplies}
        />
      </Tab>
      <Tab eventKey={2} title='Call To Actions'>
        <Field
          component={CallToActions}
          name={`${name}.ctas`}
          validate={validateCallToActions}
        />
      </Tab>
    </Tabs>
  </div>
)

DmAttachments.propTypes = {
  name: PropTypes.string
}

export default DmAttachments



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/dm-attachments/index.js